<template>
  <div class="search-section">
    <el-input
      :value="searchQuery"
      @input="updateSearch"
      placeholder="Search by name"
      prefix-icon="el-icon-search"
      clearable
      size="medium"
      class="search-input"
    />
    <div class="search-results-count">
      Showing <strong>{{ filteredCount }}</strong> of <strong>{{ totalCount }}</strong> users
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamInboxAlertSearch',
  
  props: {
    searchQuery: {
      type: String,
      default: ''
    },
    filteredCount: {
      type: Number,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    }
  },
  
  methods: {
    updateSearch(value) {
      this.$emit('update:searchQuery', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-section {
  padding: 0 20px 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  .search-input {
    max-width: 400px;
    flex: 1;
    
    @media (max-width: 768px) {
      max-width: 100%;
    }
  }

  .search-results-count {
    color: #303133;
    font-size: 13px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    padding: 0 15px 15px;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;

    .search-results-count {
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>